import React from 'react';

import { T } from 'react-translator-component';
import styled from 'styled-components';

import CCSType1 from '../../assets/CCSType1.png';
import CCSType2 from '../../assets/CCSType2.svg';
import CHAdeMO from '../../assets/CHAdeMO.png';
import plugNBR from '../../assets/plug-nbr.png';
import type1 from '../../assets/type1.png';
import type2 from '../../assets/type2.png';
import type3 from '../../assets/type3.png';

export interface Props {
  chargers: {
    connectorId: number;
    connectorPk: number;
    connectorType: string;
    lastStatus: {
      errorInfo: string;
      errorCode: string;
      status: string;
      timeStamp: string;
      usage: number;
      vendorId: string;
    };
  }[];
  stationName: string;
  chargePoint: {
    chargeBoxId: string;
    description: string;
    ocppProtocol: string;
    chargePointVendor: string;
    monthConsumption: string;
    address: any;
    connectors: any;
  };
}

interface WrapperProps {
  isMobile: boolean;
}

const getConnectorIconByConnectorType = (connectorType: string): string => {
  switch (connectorType) {
    case 'Type 1':
      return type1;

    case 'Type 2':
      return type2;

    case 'Tesla':
      return type3;

    case 'CCS Type 2':
      return CCSType2;

    case 'CCS Type 1':
      return CCSType1;

    case 'CHAdeMO':
      return CHAdeMO;

    case 'Plug NBR':
      return plugNBR;

    default:
      return type1;
  }
};

export const InfoWindowBox: React.FC<Props> = (props) => {
  const { chargePoint } = props;
  const chargers = chargePoint?.connectors;
  const totalUsage = chargers?.length > 0 && chargers?.reduce((accum, item) => accum + item.lastStatus.usage, 0);

  return chargePoint ? (
    <Div isMobile={window.innerWidth < 1024 ? true : false}>
      <h1>{chargePoint?.description || chargePoint?.chargeBoxId}</h1>
      {totalUsage ? (
        <h2>
          {T('Recharges')}: {totalUsage}
        </h2>
      ) : null}
      {chargePoint?.ocppProtocol ? <h2>Versão OCPP: {chargePoint?.ocppProtocol}</h2> : null}
      {chargePoint?.chargePointVendor ? <h2>Fabricante: {chargePoint?.chargePointVendor}</h2> : null}
      {chargePoint?.monthConsumption ? (
        <h2>Consumo: {(parseInt(chargePoint?.monthConsumption) / 1000).toFixed(2)} kWh</h2>
      ) : null}
      {chargePoint?.address?.street ? (
        <h2>
          {T('Place')}: {chargePoint?.address?.street}
        </h2>
      ) : null}
      <div className='chargesList'>
        {chargers?.length > 0 &&
          chargers.map((charger) => (
            <div key={charger.connectorId} className='chargerListItem'>
              <img src={getConnectorIconByConnectorType(charger.connectorType)} alt={charger.lastStatus.status} />
              {/* <p className="chargeListTitle"> {charger.connectorId} </p> */}
              <p>
                {T(charger.connectorType)}:{' '}
                <span className={charger.lastStatus.status}>{T(charger.lastStatus.status)}</span>{' '}
              </p>
            </div>
          ))}
      </div>
    </Div>
  ) : null;
};

export default InfoWindowBox;

const Div = styled.div`
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
  padding: ${(props: WrapperProps) => (props.isMobile ? '5px' : '10px')};
  color: rgba(0, 0, 0, 0.6);
  max-width: 250px;

  .Available {
    color: green;
  }
  .Anavailable {
    color: gray;
  }
  .Preparing,
  .Charging,
  .Reserved {
    color: orange;
  }

  .chargesList {
    display: grid;
  }

  .chargerListItem {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 8px 0;
  }

  .chargerListItem img {
    width: 20px;
  }

  .chargeListTitle {
    font-weight: 400;
    font-size: 90%;
    margin: 0 10px;
  }

  h1 {
    font-size: 100%;
    color: #0090c5;
    font-weight: 400;
  }

  h2 {
    font-size: 80%;
    font-weight: 400;
    margin: 5px 0;
  }

  p {
    font-size: 90%;
    margin: 0;
  }

  img {
    margin-right: 10px;
  }
`;
